module.exports = __webpack_public_path__ + "static/Carrion_Crawler-635b5397f41ab9a9561d1e4646e71a2e.jpg";